// Generated by IcedCoffeeScript 108.0.11
(function() {
  var make_errors;

  make_errors = require('iced-error').make_errors;

  exports.errors = make_errors({
    WRONG_SIGNING_KEY: "wrong signing key specified",
    REVOKED_KEY: "key is revoked",
    UNSEAL: "packet unseal failed"
  });

}).call(this);
